<template>
  <div>
    <seller-select-modal v-if="editable" class="component-margin" @selected="selectedSeller($event)"/>
    <b-row v-if="(editable && memberId !== '')" class="component-margin">
      <b-col sm="12">
        <payment-deposit :deposit="deposit" @editModal="editModal(null)"/>
        <!-- <b-button size="sm" @click="editModal(null)" variant="danger">{{$t('payment.addRecord')}}</b-button> -->
      </b-col>
    </b-row>
    <b-row v-if="(editable && memberId !== '') || !editable">
      <b-col sm="12">
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                  :items="items" :fields="fields"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="depositDate" slot-scope="row">
            <label>{{formatDate(row.value)}}</label>
          </template>
          <template slot="amount" slot-scope="row">
            <label v-if="row.item['depositType'] === '0'">{{formatPrice(row.item['amount'])}}</label>
            <label v-else>{{formatPrice(0)}}</label>
          </template>
          <template slot="coupon" slot-scope="row">
            <label v-if="row.item['depositType'] === '1'">{{formatPrice(row.item['amount'])}}</label>
            <label v-else>{{formatPrice(0)}}</label>
          </template>
          <template slot="update" slot-scope="row">
            <b-button size="sm" @click="editModal(row)" variant="warning">{{$t('payment.update')}}</b-button>
          </template>
          <template slot="delete" slot-scope="row">
            <b-button size="sm" @click="deleteRowConfirm(row)" variant="secondary">{{$t('payment.delete')}}</b-button>
          </template>
        </b-table>
        <b-modal ref="editModal" title="諸払登録" @ok="handleOk">
          <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" label="諸払区分" label-for="depositType">
            <b-form-select size="sm" v-model="editItem.depositType" :options="depositTypes"/>
          </b-form-group>
          <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" :label="$t('payment.table.depositDate')" label-for="depositDate">
            <date-picker id="depositDate" class="table-linput" :value="editItem.depositDate" @change="($event) => editItem.depositDate = $event"/>
          </b-form-group>
          <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" :label="$t('payment.table.amount')" label-for="amount">
            <b-form-input size="sm" id="amount" v-model="editItem.amount" type="text"/>
          </b-form-group>
          <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" :label="$t('payment.table.content')" label-for="content">
            <b-form-input size="sm" id="content" v-model="editItem.content" type="text"/>
          </b-form-group>
          <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" :label="$t('payment.table.remark1')" label-for="remark1">
            <b-form-input size="sm" id="remark1" v-model="editItem.remark1" type="text"/>
          </b-form-group>
          <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" :label="$t('payment.table.remark2')" label-for="remark2">
            <b-form-input size="sm" id="remark2" v-model="editItem.remark2" type="text"/>
          </b-form-group>
        </b-modal>
      </b-col>
    </b-row>
    <!-- <b-row v-if="(editable && memberId !== '') || !editable">
      <b-col md="6">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
      </b-col>
    </b-row> -->
    <b-modal ref="deleteRowConfirm" @ok="deleteRow" hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
    <b-modal ref="confirmMessage" ok-only hide-header>
      <div class="text-center"><label>{{confirmMessage}}</label></div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import SellerSelectModal from '@/components/common/SellerSelectModal';
import DatePicker from '@/components/common/DatePicker';
import DepositType from '@/types/DepositType'
import PaymentDeposit from '@/components/payment/PaymentDeposit';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    editable: {
      default: false,
    }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'depositDate', label: this.$i18n.t('payment.table.depositDate'), variant: 'base', class: 'table-lw10',   sortable: true },
        { key: 'amount',      label: this.$i18n.t('payment.table.amount'), variant: 'base',      class: 'table-rw10', sortable: true },
        { key: 'coupon',      label: 'クーポン額', variant: 'base',      class: 'table-rw10', sortable: true },
        { key: 'content',     label: this.$i18n.t('payment.table.content'), variant: 'warning',     class: 'table-lw',    sortable: true },
        { key: 'remark1',     label: this.$i18n.t('payment.table.remark1'), variant: 'warning',     class: 'table-lw',    sortable: true },
        { key: 'remark2',     label: this.$i18n.t('payment.table.remark2'), variant: 'warning',     class: 'table-lw',    sortable: true },
      ],
      // currentPage: 1,
      // perPage: 25,
      totalRows: 0,
      deposit: 0,
      sortBy: 'depositDate',
      sortDesc: true,
      sortDirection: 'asc',
      filter: null,
      editItem: {},
      isUpdate: false,
      confirmMessage: '',
      memberId: '',
      depositTypes: DepositType.values(),
    };
  },
  beforeMount() {
    if (this.editable === true) {
      this.fields.push({ key: 'update', label: this.$i18n.t('payment.table.update'), variant: 'warning', class: 'table-cw4', sortable: false });
      this.fields.push({ key: 'delete', label: this.$i18n.t('payment.table.delete'), variant: 'warning', class: 'table-cw4', sortable: false });
    }
  },
  created() {
    if (this.editable === false) {
      this.memberId = this.$store.state.account;
      api.getPayments(this.memberId, (data) => {
          this.items = data.items;
          this.totalRows = this.items.length;
      });
    }
  },
  methods: {
    selectedSeller($event) {
      this.memberId = $event.amazonAccount;
      api.getPayments(this.memberId, (data) => {
          this.items = data.items;
          this.totalRows = this.items.length;
          this.deposit = data.deposit;
      });
    },
    editModal(row) {
      this.editItem = {};
      this.isUpdate = false;
      if (row !== null) {
        this.isUpdate = true;
        // Object.assign(this.editItem , row.item);
        this.editItem =  Object.assign({}, this.editItem , row.item);
      }
      this.$refs.editModal.show();
    },
    handleOk() {
      if (!this.isUpdate) {
        api.registerPayments(this.memberId, this.editItem, (items) => {
          this.items = items;
          this.totalRows = this.items.length;
          this.confirmMessage = '登録内容を登録しました。';
          this.$refs.confirmMessage.show();
        });
      } else {
        api.updatePayments(this.memberId, this.editItem, (items) => {
          this.items = items;
          this.totalRows = this.items.length;
          this.confirmMessage = '登録内容を変更しました。';
          this.$refs.confirmMessage.show();
        });
      }
    },
    deleteRowConfirm(row) {
      Object.assign(this.editItem, row.item);
      this.confirmMessage = this.$i18n.t('payment.message.deleteConfirm');
      this.$refs.deleteRowConfirm.show();
    },
    deleteRow() {
      api.deletePayments(this.memberId, this.editItem, (items) => {
          this.items = items;
          this.totalRows = this.items.length;
          this.confirmMessage = '対象データを削除しました。';
          this.$refs.confirmMessage.show();
      });
    },
  },
};

Vue.component('seller-select-modal', SellerSelectModal);
Vue.component('date-picker', DatePicker);
Vue.component('payment-deposit', PaymentDeposit);
</script>

<style>
.component-margin {
  margin-bottom: 1rem;
}
.margin-bottom-off{
  margin-bottom: 0;
}

@media (min-width: 768px) {
  .table-right { text-align: right; }
  .table-lw7  { max-width:  7rem; width:  7rem; text-align:left; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-lw { word-wrap: break-word; max-width: 20rem; text-align:left; }
}
</style>
